
import { useStore } from "vuex";
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { TelephonyType } from "@moderrotech/servers-communication-library/src/types";
import {
  ResizeObserverEntry,
  useResizeObserver,
  useUserMedia
} from "@vueuse/core";
import _ from "lodash";
import { useAVMedia } from "@/composables/customAV";

export default {
  setup() {
    const store = useStore();

    const canvas = ref(null),
      container = ref(null);

    const pixelsPerLine = 5;

    const telephonyType = computed(() => store.state.telephonyType);

    const props = useAVMedia(canvas, {
      type: "frequ",
      frequDirection: "mo",
      lineColor: "#4DFDE9"
    });

    const { stream: stagingStream, stop: stopStagingStream } = useUserMedia({
      enabled: store.state.config.config.envMode === "staging"
    });

    const stream = computed(
      () =>
        stagingStream.value ||
        (telephonyType.value === TelephonyType.webex
          ? store.state.webex.streams.remoteVideo
          : telephonyType.value === TelephonyType.webrtc
          ? store.state.webrtc.streams.remote
          : null)
    );

    watch(
      () => stream.value,
      v => {
        (props as { media: MediaStream | null }).media = v;
      },
      { immediate: true }
    );

    onBeforeUnmount(() => stopStagingStream());

    onMounted(() => {
      useResizeObserver(
        container.value,
        (entries: ReadonlyArray<ResizeObserverEntry>) => {
          if (!_.first(entries)) {
            return;
          }

          (props as { canvWidth: number | null }).canvWidth =
            entries[0].contentRect.width;
          (props as { canvHeight: number | null }).canvHeight =
            entries[0].contentRect.height;
          (props as { frequLnum: number | null }).frequLnum =
            entries[0].contentRect.width / pixelsPerLine;
        }
      );
    });

    return {
      container,
      canvas,
      stream
    };
  }
};
